import { createSlice } from '@reduxjs/toolkit';
import StatusCode from '../../utils/StatusCode';

const initialState = {
  data: [],
  count: 0,
  pageIndex: 1,
  size: 10,
  search: '',
  sortingData: [], // ← ADD: current sorting state (array of { id: string, sort: boolean, desc: boolean })
  status: StatusCode.IDLE
};

const recursiveRemove = (list: any, id: string) => {
  return list
    .map((item: any) => ({ ...item }))
    .filter((item: any) => {
      if ('childCategory' in item) {
        item.childCategory = recursiveRemove(item.childCategory, id);
      }
      return item._id !== id;
    });
};

const streamSlice = createSlice({
  name: 'stream',
  initialState,
  reducers: {
    getStream(state, { payload }) {
      state.data = payload;
    },

    addStream(state, { payload }) {
      state.data = payload;
    },

    delStream(state, { payload }) {
      return {
        ...state,
        data: recursiveRemove(state.data, payload)
      };
    },

    updateStream(state, { payload }) {
      state.data = payload;
    },

    setStreamSearch(state, { payload }) {
      state.search = payload;
    },

    setStreamTableSize(state, { payload }) {
      state.size = payload;
    },

    setStreamPageIndex(state, { payload }) {
      state.pageIndex = payload;
    },

    setStreamCount(state, { payload }) {
      state.count = payload;
    },
    setSortingValue(state, { payload }) {
      state.sortingData = payload;
    },

    resetStreams: () => {
      return initialState;
    },
  }
});

export const {
  getStream,
  addStream,
  delStream,
  updateStream,
  setStreamTableSize,
  setStreamPageIndex,
  setStreamCount,
  setStreamSearch,
  setSortingValue,     // ← EXPORT THIS
  resetStreams
} = streamSlice.actions;
export default streamSlice.reducer;